export default {
  noticeError (err, customAttributes = null) {
    if (window.newrelic !== undefined) {
      window.newrelic.noticeError(err, customAttributes)
    } else {
      console.log('On production this error will be sent to NewRelic:')
      console.error(err)
    }
  }
}



// WEBPACK FOOTER //
// ./WebResources/vue/shared/lib/new-relic.js